import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtilityServ {
  constructor() {}
  removeAccents(str) {
    if (!str) {
      return '';
    }
    const accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const accentsOut = 'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    str = str.split('');
    str.forEach((letter, index) => {
      const i = accents.indexOf(letter);
      if (i !== -1) {
        str[index] = accentsOut[i];
      }
    });
    return str.join('');
  }
  // Validar dos cadenas omitiendo acentos
  ecualsNoAcents(str1, str2) {
    str1 = this.removeAccents(str1).toLowerCase();
    str2 = this.removeAccents(str2).toLowerCase();
    return str1.indexOf(str2) > -1;
  }
  strAutocompl(string, term, color = 'red') {
    const stringTerm = this.removeAccents(term);
    const stringNoAcents = this.removeAccents(string);
    const rejex = new RegExp(stringTerm, 'i');
    return stringNoAcents.replace(rejex, '<span style="color: ' + color + ' !important;">' + stringTerm.toUpperCase() + '</span>');
  }
}
